import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';
import * as Sentry from '@sentry/react';
import '@xyflow/react/dist/style.css';
import { getVersionString } from './utils/version';

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://f415bb392cb4cb3fa8ef56f6382dbb45@o4509037822345216.ingest.de.sentry.io/4509045827436624',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    release: `vigilant-frontend@${getVersionString()}`,
    environment: import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE,
  });
}

// Tempo devtools disabled - was causing React context issues
// import { TempoDevtools } from 'tempo-devtools';
// TempoDevtools.init();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find root element');
}

// A data router is required for navigation blocking (`useBlocker`). The single
// splat route keeps the existing declarative <Routes> tree inside App working.
const router = createBrowserRouter([{ path: '*', element: <App /> }]);

ReactDOM.createRoot(rootElement).render(
  // <React.StrictMode>
  <HelmetProvider>
    <RouterProvider router={router} />
  </HelmetProvider>
  // </React.StrictMode>
);
